import { httpClient, HttpError } from "@coworker/http-client";
import { defsCombinations } from "../types/article";
import { LocalCombinationItem } from "@coworker/apprestructured/src/shared/types/localCombinationItem";

export const getDexfCombination = async (combinationNumber: string) => {
  try {
    return await httpClient.data.get<defsCombinations[]>(
      "/dexf/getCombination",
      {
        params: {
          combinationNumber,
        },
      }
    );
  } catch (error) {
    if (error instanceof HttpError && error.status === 404) {
      return null;
    }
    console.error("Fetch error:", error);
  }
  return null;
};

export const mapDexfCombinationToLocalCombinationItem = (
  combination: defsCombinations,
  countryId?: string
): LocalCombinationItem => {
  const combinationName =
    combination.combinationNames?.find(
      (name) => name.country_code === countryId
    ) ?? combination.combinationNames?.[0];

  return {
    name:
      combinationName?.name ||
      combinationName?.combination_name ||
      combination.combinationNumber,
    no: combination.combinationNumber,
    type: combination.combinationType,
    noFormatted: combination.combinationNumber,
    description: "",
    productTypeName: "",
    paNo: "",
    hfbNo: "",
    source: "dexf",
    outgoing: false,
    smallImageUrl: "",
    imageUrl: "",
    itemsCountInCombination: combination.articlesCount || 0,
    itemsInCombination: combination.articleCombinations || [],
  };
};
